import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function AccountCircleIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox='0 0 28 28'>
      <path
        d="M6.825 19.95q1.487-1.137 3.325-1.794A11.4 11.4 0 0 1 14 17.5q2.012 0 3.85.656a12.2 12.2 0 0 1 3.325 1.794 9 9 0 0 0 1.59-2.713q.567-1.516.568-3.237 0-3.879-2.727-6.606T14 4.667 7.393 7.394 4.666 14q0 1.72.57 3.237a9 9 0 0 0 1.589 2.713M14 15.167q-1.722 0-2.902-1.182-1.182-1.181-1.182-2.902 0-1.72 1.182-2.902Q12.278 7.001 14 7q1.72 0 2.902 1.181 1.18 1.182 1.181 2.902 0 1.721-1.181 2.902T14 15.167m0 10.5a11.4 11.4 0 0 1-4.55-.92 11.8 11.8 0 0 1-3.704-2.493 11.8 11.8 0 0 1-2.494-3.704A11.4 11.4 0 0 1 2.333 14q0-2.42.919-4.55a11.8 11.8 0 0 1 2.494-3.704A11.8 11.8 0 0 1 9.45 3.252 11.4 11.4 0 0 1 14 2.333q2.42 0 4.55.919a11.8 11.8 0 0 1 3.704 2.494 11.8 11.8 0 0 1 2.494 3.704 11.4 11.4 0 0 1 .918 4.55q0 2.42-.918 4.55a11.8 11.8 0 0 1-2.494 3.704 11.8 11.8 0 0 1-3.704 2.494 11.4 11.4 0 0 1-4.55.919"
        fill="currentColor"
      />
    </BaseIcon>
  )
}
